module.exports = __webpack_public_path__ + "img/1485190384.2adf42e3.jpg";